module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "calendar__info"
  }, [_c('div', {
    staticClass: "calendar__info__item"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('CAN_I_USE_BRASTER')))]), _vm._v(" "), (_vm.brasterAllowed) ? _c('div', {
    staticClass: "is-relative"
  }, [_c('img', {
    staticClass: "img-info",
    attrs: {
      "src": require("../../assets/images/icons/ico-ok-green.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t('YES')))]), _vm._v(" "), _c('router-link', {
    staticClass: "arrow-link",
    attrs: {
      "to": '/moje-dane/'
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('CHECK_IF_DATA_ACTUAL')) + " "), _c('img', {
    attrs: {
      "src": require("./../../assets/images/arrow-red.png")
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.brasterAllowed) ? _c('div', {
    staticClass: "is-relative"
  }, [_c('img', {
    staticClass: "img-info",
    attrs: {
      "src": require("../../assets/images/icons/ico-not-ok.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t('NO')))]), _vm._v(" "), _c('router-link', {
    staticClass: "arrow-link",
    attrs: {
      "to": '/moje-dane/'
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('CHECK_IF_DATA_ACTUAL')) + " "), _c('img', {
    attrs: {
      "src": require("./../../assets/images/arrow-red.png")
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.brasterAllowed) ? _c('div', {
    staticClass: "box-shadow calendar__info__tooltip bottom mt-3"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('UNFORTUNATELY_YOU_CAN_NOT')) + "\n                "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.linkClicked(_vm.$t('LINK_WARNINGS'))
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ALL_CONTRAINDICATIONS')))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011fb328","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/period-modules/braster-disallowed.vue
// module id = 1153
// module chunks = 0